export default {"src":"/_next/static/media/password.8f62241c.svg","height":512,"width":513};